<template>
    <div v-if="hasAnyAddress" class="w-full"
        :class="[
            {'flex flex-row flex-wrap': horizontal},
            {'hover:cursor-pointer hover:opacity-70 text-sky': googleLink && address?.googlePlacesId}
        ]"
        @click="googleLink && address?.googlePlacesId ? linkToGoogleMaps(address?.googlePlacesId) : null"
        >
        <!-- Street line -->
        <div v-if="lines.street" class="flex flex-row p-0.5">
            <div class="whitespace-normal px-0.5">{{lines.street}}</div>
        </div>
        <!-- Address line two -->
        <div v-if="addressTwoLine" class="flex flex-row p-0.5">
            <div class="whitespace-normal px-0.5">{{addressTwoLine}}</div>
        </div>
        <!-- City / state / postal -->
        <div v-if="lines.cityStateZip" class="flex flex-row flex-wrap p-0.5">
            <div class="whitespace-normal px-0.5">{{lines.cityStateZip}}</div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue'
import { linkToGoogleMaps, formatAddressLines } from '@/shared'

export default {
    props: {
        address: {
            type: Object,
            default: () => ({})
        },
        showAddressTwo: {
            type: Boolean,
            default: true
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        googleLink: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        // Computed
        const hasAnyAddress = computed(() =>
            props.address && typeof props.address === 'object' &&
            ['street_number', 'street', 'addressTwo', 'address2', 'city', 'state', 'postalCode']
                .some(k => props.address[k])
        )
        const lines = computed(() => formatAddressLines(props.address))
        const addressTwoLine = computed(() => (props.showAddressTwo && lines.value.line2) || '')

        return {
            hasAnyAddress,
            lines,
            addressTwoLine,
            linkToGoogleMaps
        }
    }
}
</script>

<style>

</style>